import { Button, Typography,Box, Grid, Stack, Select, MenuItem } from "@mui/material";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";

import config 		from "../../../common/Config";
import Loading 		from "../../../components/Loading";
import RankingTable from "./RankingTable";

const RankingCompact = (props) => {

	const [rankingData, setRankingData] = useState()
	const [selectedIndex, setSelectedIndex] = useState('IBOV');

	useEffect(() => {
		fetch(config.apiUrl +'/api/ranking')
		.then(results => results.json())
		.then(results => {
			setRankingData(results)
		})
	}, [])

	if (!rankingData) return <Loading />

	const currentExchangeStocks = rankingData.filter(r => r.indexName == selectedIndex)[0]?.stocks || []

	return (
		<Box>
			<Grid container spacing={1}>
				<Grid item xs={12}>
					<Stack direction={'row'} justifyContent="space-between" alignItems="center"	>
						<Typography variant="h5" fontWeight={800}>Lista Top 5</Typography>
						<Select size="small" value={selectedIndex} onChange={(e) => setSelectedIndex(e.target.value)}>
							<MenuItem value="IBOV">Ibovespa</MenuItem>
							<MenuItem value="SP500">SP500</MenuItem>
						</Select>
					</Stack>
				</Grid>
				<Grid item xs={12} sm={6} xl={3}>				
					<RankingTable 
						title="Maiores Altas"
						field="changePercentage"
						color="#4caf50"
						data={currentExchangeStocks?.sort((a,b) => parseFloat(b.changePercentage) - parseFloat(a.changePercentage)).slice(0,5)}
					/>							
				</Grid>
				<Grid item xs={12} sm={6} xl={3}>				
					<RankingTable 
						title="Maiores Baixas"
						field="changePercentage"
						color="#d32f2f"
						data={currentExchangeStocks?.sort((a,b) => parseFloat(a.changePercentage) - parseFloat(b.changePercentage)).slice(0,5)}
					/>							
				</Grid>					
				<Grid item xs={12} sm={6} xl={3}>
					<RankingTable 
						title="Menores P/Ls"
						field="priceEarnings"
						data={currentExchangeStocks?.filter(s => s.priceEarnings > 0).sort((a,b) => a.priceEarnings - b.priceEarnings).slice(0,5)}
					/>
				</Grid>
				<Grid item xs={12} sm={6} xl={3}>
					<RankingTable 
						title="Maiores D/Ys"
						field="dividendYield"
						data={currentExchangeStocks?.sort((a,b) => parseFloat(b.dividendYield) - parseFloat(a.dividendYield)).slice(0,5)}
					/>
				</Grid>
				<Grid item xs={12} justifyContent={'center'} alignItems={'center'} textAlign={'center'}>
					<Button variant="contained" component={Link} to="/rankings" sx={{mt: 2}}>Ver Outras Listas</Button>	
				</Grid>
			</Grid>
		</Box>
	);
}

export default RankingCompact;